import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import type { User } from '../../shared/api';
import { Avatar } from './Avatar';

export function UserMenu({ user, onSignOut }: { user: User; onSignOut: () => void }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (event: MouseEvent | KeyboardEvent) => {
      if (event instanceof KeyboardEvent ? event.key === 'Escape' : !ref.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', close);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', close);
    };
  }, [open]);

  return (
    <div className="user-menu" ref={ref}>
      <button
        type="button"
        className="user-menu__button"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={`Account: ${user.name ?? user.email}`}
        onClick={() => setOpen((value) => !value)}
      >
        <Avatar user={user} className="user-menu__avatar" />
      </button>
      {open && (
        <div className="user-menu__panel" role="menu">
          <p className="user-menu__name">{user.name ?? 'Signed in'}</p>
          <p className="user-menu__email">{user.email}</p>
          <Link to="/categories" role="menuitem" className="user-menu__link" onClick={() => setOpen(false)}>
            Categories
          </Link>
          <Link to="/household" role="menuitem" className="user-menu__link" onClick={() => setOpen(false)}>
            Household
          </Link>
          <Link to="/friends" role="menuitem" className="user-menu__link" onClick={() => setOpen(false)}>
            Friends
          </Link>
          <button
            type="button"
            role="menuitem"
            className="btn btn--secondary btn--small"
            onClick={() => {
              setOpen(false);
              onSignOut();
            }}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
